module.exports = __webpack_public_path__ + "media/placeholders/default-6b28a798.svg";